<template>
  <div class="j-container factory-show-container">
    <div class="j-title title factory-title">
      {{ $t('home.factory_show') }}
    </div>

    <div>
      <a-row :gutter="[30, 30]" v-if="factories.length > 0">
        <a-col :xs="24" :sm="24" :md="8" v-for="f in factories" :key="f.id">
          <div class="factory">
            <div class="factory-img">
              <img :src="baseUrl + f.newsImageUrl" />
            </div>
            <div class="factory-desc">
              {{ $t(f.title) }}
            </div>
          </div>
        </a-col>
      </a-row>
      <div
        v-if="loaded && factories.length === 0"
        class="j-coming-soon j-content"
      >
        {{ $t('common.coming_soon') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'ProductSection',
  props: {
    factories: {
      type: Array,
      required: true,
      default: () => []
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      baseUrl
    };
  }
});
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  margin-bottom: 30px;
}

.factory-show-container {
  margin-bottom: 40px;
  &::after {
    display: table;
    content: ' ';
  }

  .factory-title {
    margin-bottom: 40px;
  }

  .factory {
    .factory-img {
      height: 220px;
      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }

    .factory-desc {
      display: flex;
      align-items: center;
      padding: 20px;
      justify-content: center;
      background: $secondary-color1;
      font-size: $content-fontsize;
    }
  }
}
</style>
